import { BaseModel } from './base-model';
import { TerminalInfo, TimestampAndTerminal, TerminalPilotInfo, TerminalUpdateMessage } from './types/terminals-model.types';

export abstract class TerminalsModelBase extends BaseModel
{
    abstract get terminals(): Map<string, TerminalInfo>;
    abstract get terminalsByCity(): Map<string, TerminalInfo[]>
    abstract getTerminal(locationId: string): TerminalInfo|undefined;
    abstract getTerminalsByCity(cityId: string): TerminalInfo[]|undefined;
    abstract getCity(locationId: string): string|undefined;
    abstract getTerminalLocaltime(locationId: string, utc: string): Promise<string>;
    abstract getTerminalLocaltimeBatch(timestampsAndTerminals: TimestampAndTerminal[]): Promise<string[]>
    abstract getUTCFromTerminalLocaltime(locationId: string, local: string): Promise<string>;
    abstract getTerminalPortMemo(locationId: string): Promise<any>;
    abstract getTerminalPilotInfo(locationId: string): Promise<TerminalPilotInfo>;
    abstract createTerminal(terminal: TerminalUpdateMessage): Promise<void>;
    abstract isPseudoTerminal(locationId: string): boolean;
}

let TerminalsModel: TerminalsModelBase|null = null;

function setTerminalsModel(model: TerminalsModelBase)
{
    TerminalsModel = model;
}

export { TerminalsModel, setTerminalsModel };
